import React from 'react'
import { Link } from 'react-router-dom'
import { Box, Flex, Heading, Text, Image, SimpleGrid } from '@chakra-ui/react'
import logoImg from '../assets/images/logo_flag.png'
import { Footer } from '../components/Footer'

const HomePage = () => {
  return (
    <Box minH="100vh" display="flex" flexDirection="column" bg="white">
      <Flex
        as="header"
        w="100%"
        py={12}
        px={6}
        justifyContent="center"
        alignItems="center"
      >
        <Flex flexDirection="column" alignItems="center" gap={4}>
          <Box
            w="56px"
            h="56px"
            borderRadius="xl"
            display="flex"
            alignItems="center"
            justifyContent="center"
            bg="white"
            boxShadow="sm"
            border="1px solid"
            borderColor="gray.200"
          >
            <Image
              src={logoImg}
              alt="EXCELLO"
              w="36px"
              h="36px"
              objectFit="contain"
            />
          </Box>
          <Heading
            as="h1"
            fontSize={{ base: '3xl', md: '4xl' }}
            fontWeight="extrabold"
            letterSpacing="0.1em"
            color="gray.900"
            textAlign="center"
          >
            EXCELLO
          </Heading>
        </Flex>
      </Flex>

      <Flex
        as="main"
        flex={1}
        alignItems="center"
        justifyContent="center"
        w="100%"
        maxW="1280px"
        mx="auto"
        px={6}
        pb={20}
      >
        <SimpleGrid columns={{ base: 1, md: 2 }} gap={8} w="100%" maxW="896px">
          <Link to="/youtube">
            <Box
              as="article"
              position="relative"
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              p={{ base: 12, md: 12 }}
              bg="white"
              border="1px solid"
              borderColor="gray.200"
              borderRadius="xl"
              boxShadow="sm"
              _hover={{
                boxShadow: 'xl',
                borderColor: 'blue.500',
                '& .home-card-gradient': { opacity: 1 },
                '& .home-card-icon-wrap': { bg: 'blue.500', color: 'white' },
                '& .home-card-cta': { opacity: 1 },
              }}
              transition="all 0.3s"
            >
              <Box
                className="home-card-gradient"
                position="absolute"
                inset={0}
                bgGradient="linear(to-br, blue.50, transparent)"
                borderRadius="xl"
                opacity={0}
                transition="opacity 0.3s"
              />
              <Flex
                className="home-card-content"
                position="relative"
                zIndex={1}
                flexDirection="column"
                alignItems="center"
                gap={8}
              >
                <Flex
                  className="home-card-icon-wrap"
                  w={24}
                  h={24}
                  borderRadius="full"
                  alignItems="center"
                  justifyContent="center"
                  bg="gray.50"
                  color="blue.500"
                  transition="all 0.5s"
                >
                  <Box
                    as="span"
                    className="material-symbols-outlined"
                    fontSize="3rem"
                  >
                    play_circle
                  </Box>
                </Flex>
                <Flex flexDirection="column" gap={2} alignItems="center">
                  <Heading as="h2" size="lg" color="gray.900">
                    YouTube Videos
                  </Heading>
                  <Text color="gray.500" fontWeight="medium">
                    Watch our latest videos
                  </Text>
                </Flex>
              </Flex>
              <Flex
                className="home-card-cta"
                mt={8}
                alignItems="center"
                gap={2}
                color="blue.500"
                fontWeight="bold"
                fontSize="sm"
                opacity={0}
                transition="opacity 0.3s"
              >
                <span>Explore videos</span>
                <Box
                  as="span"
                  className="material-symbols-outlined"
                  fontSize="1rem"
                >
                  arrow_forward
                </Box>
              </Flex>
            </Box>
          </Link>

          <Link to="/links">
            <Box
              as="article"
              position="relative"
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              p={{ base: 12, md: 12 }}
              bg="white"
              border="1px solid"
              borderColor="gray.200"
              borderRadius="xl"
              boxShadow="sm"
              _hover={{
                boxShadow: 'xl',
                borderColor: 'blue.500',
                '& .home-card-gradient': { opacity: 1 },
                '& .home-card-icon-wrap': { bg: 'blue.500', color: 'white' },
                '& .home-card-cta': { opacity: 1 },
              }}
              transition="all 0.3s"
            >
              <Box
                className="home-card-gradient"
                position="absolute"
                inset={0}
                bgGradient="linear(to-br, blue.50, transparent)"
                borderRadius="xl"
                opacity={0}
                transition="opacity 0.3s"
              />
              <Flex
                className="home-card-content"
                position="relative"
                zIndex={1}
                flexDirection="column"
                alignItems="center"
                gap={8}
              >
                <Flex
                  className="home-card-icon-wrap"
                  w={24}
                  h={24}
                  borderRadius="full"
                  alignItems="center"
                  justifyContent="center"
                  bg="gray.50"
                  color="blue.500"
                  transition="all 0.5s"
                >
                  <Box
                    as="span"
                    className="material-symbols-outlined"
                    fontSize="3rem"
                  >
                    language
                  </Box>
                </Flex>
                <Flex flexDirection="column" gap={2} alignItems="center">
                  <Heading as="h2" size="lg" color="gray.900">
                    Company Websites
                  </Heading>
                  <Text color="gray.500" fontWeight="medium">
                    Browse our websites and platforms
                  </Text>
                </Flex>
              </Flex>
              <Flex
                className="home-card-cta"
                mt={8}
                alignItems="center"
                gap={2}
                color="blue.500"
                fontWeight="bold"
                fontSize="sm"
                opacity={0}
                transition="opacity 0.3s"
              >
                <span>Browse websites</span>
                <Box
                  as="span"
                  className="material-symbols-outlined"
                  fontSize="1rem"
                >
                  arrow_forward
                </Box>
              </Flex>
            </Box>
          </Link>
        </SimpleGrid>
      </Flex>

      <Footer />
    </Box>
  )
}

export default HomePage
